// extracted by mini-css-extract-plugin
module.exports = {"reviews":"_2z8gfzC2"};